// @ts-check
import React, { useMemo } from "react"
import { flexRender } from "@tanstack/react-table"
import { buildPinnedTableStyle } from "../../utils/TableLayout.utils"

/**
 * @param {import("./TableCell.component.types").TableCellProps} props
 */
export const TableCell = (props) => {
  const { cell } = props

  /** @type {import("../../types/table").ExpandedColumnMeta | undefined} */
  const columnMeta = cell.column.columnDef.meta

  const className = `table__cell ${columnMeta?.className ?? ""}`

  const pinnedStyle = useMemo(
    () => buildPinnedTableStyle(cell.column),
    [cell.column]
  )

  return (
    <td className={className} style={{ ...pinnedStyle }}>
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  )
}
